import { RootState } from '../../RootState';

const selectIsInEmployeeCustomerGroup = (state: RootState): boolean => {
  return (
    state.user.isInEmployeeCustomerGroup === true &&
    state.auth.authenticatedUserId !== null &&
    state.user.employeeGroupCheckedForUserId === state.auth.authenticatedUserId
  );
};

export { selectIsInEmployeeCustomerGroup };
